




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Card } from '../models/Card';
import { Player } from '../models/Player';
import { PlayerRole } from '../models/PlayerRole';
import BarsGraph from './Graphs/BarsGraph.vue';

@Component({
  components: { BarsGraph }
})
export default class VotingResults extends Vue {
  @Prop({ required: true }) players!: Player[];
  @Prop({ required: true }) cards!: Card[];

  barValues: { key: string; value: number }[] = [];

  @Watch('players', { deep: true })
  @Watch('cards', { deep: true })
  updateBarValues() {
    if (!this.cards) this.barValues = [];

    const getVotesForCard = (card: Card) => {
      return this.players
        ? this.players.filter(p => p.role === PlayerRole.Player && p.selectedCard?.id === card.id)
            .length
        : 0;
    };

    this.barValues = this.cards.map(c => ({
      key: c.text,
      value: getVotesForCard(c)
    }));
  }

  created() {
    this.updateBarValues();
  }
}
